import React,{ useState, useEffect } from "react";
import { 
    Button,
    Modal,
} from 'antd';

import { 
    CloseCircleOutlined
} from '@ant-design/icons';

function TVSupportedDevices() {
    const [modalOpen, setModalOpen] = useState( false );

    const handleModalCancel = () => {
        setModalOpen(false);
    }

    return (
        <div className="startca-react-supported-devices-container">
            <Button 
                type="primary"
                onClick={ () => setModalOpen( true ) }>
                See supported devices
            </Button>
            <Modal
                //title={ 'modal title' }
                centered
                open={ modalOpen }
                onCancel={ handleModalCancel }
                width={ '70%' }
                footer={ <></> }
            >
                <div className="startca-react-supported-devices-container" style={{textAlign:"center"}}>
                    <h2>Supported devices list</h2>
                    <div style={{ 
                        textAlign:"left", 
                        margin:"0rem auto 4rem auto", 
                        maxWidth: "725px" }}>
                        <p>Visit <a style={{ fontWeight:'500' }} href="https://watch.start.tv" target="_blank" >https://watch.start.tv</a> to enjoy on your computer.</p>
                        <h3>Set-top box</h3>
                        <ul>
                            <li>Inspur IPBS9510 Android Set Top Box</li>
                            <li>Amigo 7x Android TV Set Top Box</li>
                        </ul>
                        <h3>Amazon Fire TV</h3>
                        <ul>
                            <li>Fire OS 7 or later</li>
                        </ul>
                        <h3>Android</h3>
                        <ul>
                            <li>Phones and Tablets: Android 9.0 or later</li>
                        </ul>
                        <h3>Apple</h3>
                        <ul>
                            <li>Phones and Tablets: iOS 12.0 or later</li>
                            <li>Apple TV 13.4.8 or later</li>
                        </ul>
                        <h3>Google</h3>
                        <ul>
                            <li>Google TV: Model 2020 and later</li>
                            <li>Google Chromecast (w/ remote)</li>
                        </ul>
                        <h3>Browsers</h3>
                        <p>Make sure whichever browser you prefer is up to date with the latest version. <a style={{ fontWeight:'500' }} href="https://watch.start.tv" target="_blank">https://watch.start.tv</a> is compatible with most HTML5 enabled browsers.</p>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default TVSupportedDevices